import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import { SidebarItem } from '@backstage/core-components';
import { useNavigate } from 'react-router-dom';

const ODP_V2_THEME_ID = 'odp-v2-dark';

export const ThemeSwitchButton = () => {
  const appThemeApi = useApi(appThemeApiRef);
  const navigate = useNavigate();

  const handleSwitch = () => {
    appThemeApi.setActiveThemeId(ODP_V2_THEME_ID);
    navigate('/home');
  };

  return (
    <SidebarItem
      icon={WbSunnyIcon as never}
      text="New Design"
      onClick={handleSwitch}
      data-testid="new-design-button"
    />
  );
};
